import { render, staticRenderFns } from "./sourceName.vue?vue&type=template&id=2d5360f7&"
import script from "./sourceName.vue?vue&type=script&lang=js&"
export * from "./sourceName.vue?vue&type=script&lang=js&"
import style0 from "./sourceName.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports